import {Button, Table} from "antd";
import React, {useState} from "react";
import TransferToNextDayModal from "../transferToNextDayModal/TransferToNextDayModal";
import {Link} from "react-router-dom/cjs/react-router-dom.min";
import SendBackToCompanyModal from "../sendBackToCompanyModal/SendBackToCompanyModal";

const UndeliveredShipmentsTable = ({
    undeliveredShipments,
    undeliveredShipmentsLoading,
    refetch,
    page,
    setPage
}) => {
    const [transferToNextDayModalVisible, setTransferToNextDayModalVisible] = useState(false);
    const [sendBackToCompanyModalVisible, setSendBackToCompanyModalVisible] = useState(false);
    const [shipmentId, setShipmentId] = useState("");
    const [undeliveredShipmentId, setUndeliveredShipmentId] = useState("");

    const columns = [
        {
            title: "Gün",
            dataIndex: "date",
            render: (_, record) => {
                return record.date.split("T")[0];
            }
        },
        {
            title: "Paket Numarası",
            dataIndex: "shipmentNumber"
        },
        {
            title: "Müşteri Adı",
            dataIndex: "receiverName"
        },
        {
            title: "Müşteri Telefon Numarası",
            dataIndex: "receiverPhone"
        },
        {
            title: "İl",
            dataIndex: "city"
        },
        {
            title: "İlçe",
            dataIndex: "district"
        },

        {
            title: "İade Talebi Durumu",
            dataIndex: "status",
            render: (_, record) => {
                return record.status === "pending" ? (
                    <span>Beklemede</span>
                ) : record.status === "completed" ? (
                    <span>Tamamlandı</span>
                ) : record.status === "created" ? (
                    <span>Oluşturuldu</span>
                ) : (
                    record.status
                );
            }
        },
        {
            title: "Kurye",
            dataIndex: "courier",
            render: (_, record) => {
                return record?.courier?.fullname ? (
                    <Link target="_blank" to={`/couriers/${record?.courier?._id}`}>
                        {record?.courier?.fullname}
                    </Link>
                ) : (
                    "-"
                );
            }
        },
        {
            title: "Paket Sayısı",
            dataIndex: "packageCount",
            render: (_, record) => {
                return record.packageCount + " Paket" || "-";
            }
        },
        {
            title: "İade Sebebi",
            dataIndex: "returnReason",
            render: returnReason => {
                return returnReason === "missing_package"
                    ? "Kayıp paket"
                    : returnReason === "receiver_rejected"
                    ? "Alıcı reddetti"
                    : returnReason === "damaged_package"
                    ? "Paket hasarlı"
                    : returnReason === "lost_package"
                    ? "Paket kayboldu"
                    : "-";
            }
        },
        {
            title: "Aktarma Sayısı",
            dataIndex: "nextDayStack"
        },
        {
            title: "Ayarlar",
            dataIndex: "settings",
            render: (_, record) =>
                record.processType ? (
                    record.processType === "schedule_next_day" ? (
                        <div>Sonraki Güne Aktarıldı</div>
                    ) : record.processType === "send_back_to_company" ? (
                        <div>Firmaya Geri Gönderildi</div>
                    ) : (
                        "-"
                    )
                ) : (
                    <div style={{display: "flex", gap: "10px"}}>
                        <Button type="primary" onClick={() => handleScheduleNextDay(record)}>
                            Sonraki Güne Aktar
                        </Button>
                        <Button type="ghost" onClick={() => handleSendBackToCompany(record)}>
                            Firmaya Geri Gönder
                        </Button>
                    </div>
                )
        }
    ];

    const handleScheduleNextDay = record => {
        setTransferToNextDayModalVisible(true);
        setShipmentId(record.shipmentId);
        setUndeliveredShipmentId(record._id);
    };

    const handleSendBackToCompany = async record => {
        setSendBackToCompanyModalVisible(true);
        setShipmentId(record.shipmentId);
        setUndeliveredShipmentId(record._id);
    };

    const onPageChange = page => {
        setPage(page);
    };

    return (
        <>
            <Table
                loading={undeliveredShipmentsLoading}
                dataSource={undeliveredShipments.data}
                columns={columns}
                scroll={{x: 1000}}
                pagination={{
                    current: page,
                    pageSize: undeliveredShipments?.pagination?.limit,
                    total: undeliveredShipments?.pagination?.total,
                    onChange: onPageChange
                }}
            ></Table>
            <TransferToNextDayModal
                transferToNextDayModalVisible={transferToNextDayModalVisible}
                setTransferToNextDayModalVisible={setTransferToNextDayModalVisible}
                shipmentId={shipmentId}
                undeliveredShipmentsRefetch={refetch}
                undeliveredShipmentId={undeliveredShipmentId}
            />
            <SendBackToCompanyModal
                sendBackToCompanyModalVisible={sendBackToCompanyModalVisible}
                setSendBackToCompanyModalVisible={setSendBackToCompanyModalVisible}
                shipmentId={shipmentId}
                undeliveredShipmentsRefetch={refetch}
                undeliveredShipmentId={undeliveredShipmentId}
            />
        </>
    );
};

export default UndeliveredShipmentsTable;
